
















































































































import { localISODate, toDateInputs } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import RetensiStore from "@/store/modules/RetensiAlihMediaStore";
import { RetensiSession } from "@/types/RetensiAlihMedia";
import RetensiStepIdentitas from "@/components/retensi-alih-media/StepIdentitas.vue";
import RetensiStepBatchKandidat from "@/components/retensi-alih-media/StepBatchKandidat.vue";
import RetensiStepDokumen from "@/components/retensi-alih-media/StepDokumen.vue";
import RetensiStepChecklist from "@/components/retensi-alih-media/StepChecklist.vue";
import RetensiStepTemuan from "@/components/retensi-alih-media/StepTemuan.vue";
import RetensiStepSignature from "@/components/retensi-alih-media/StepSignature.vue";

@Component({
  name: "RetensiAlihMediaWizardPage",
  components: {
    RetensiStepIdentitas,
    RetensiStepBatchKandidat,
    RetensiStepDokumen,
    RetensiStepChecklist,
    RetensiStepTemuan,
    RetensiStepSignature,
  },
})
export default class RetensiAlihMediaWizardPage extends Vue {
  store = RetensiStore;
  step = 1;
  saving = false;
  step1Valid = false;

  formIdentitas: Partial<RetensiSession> = {
    tanggal_audit: localISODate(),
    periode_audit_dari: localISODate(),
    periode_audit_sd: localISODate(),
    rs_name_snapshot: "RSUD Panembahan Senopati Bantul",
    nama_unit_rme: "Unit Rekam Medis dan Informasi Kesehatan",
    nama_direktur: "",
    pmik_pelaksana_id: 0,
    pmik_pelaksana_nama: "",
    pmik_str_no: "",
    pmik_str_exp: "",
    pmik_sik_no: "",
    pmik_sik_exp: "",
    auditor_id: 0,
    auditor_nama: "",
    auditor_str_no: "",
  };

  get session(): RetensiSession | null {
    return this.store.currentSession;
  }

  async mounted() {
    // Bila navigasi dari Daftar dengan ?session=ID, prefill dari existing.
    const existing = this.$route.query.session;
    if (existing) {
      await this.store.fetchSession(Number(existing));
      if (this.session) {
        Object.assign(this.formIdentitas, toDateInputs(this.session));
        // Lompat ke step terakhir yang belum selesai.
        this.step = this.detectStepFromStatus(this.session.status);
      }
    }
  }

  detectStepFromStatus(status: string | undefined): number {
    if (status === "checklist_done" || status?.startsWith("signed_") || status === "finalized" || status === "locked") {
      return 6;
    }
    if (this.session?.batches && this.session.batches.length > 0) return 4;
    if (status === "draft") return 2;
    return 1;
  }

  async goStep1Next() {
    this.saving = true;
    try {
      if (!this.session) {
        await this.store.createSession(this.formIdentitas);
      } else {
        await this.store.updateSession({
          id: this.session.id!,
          data: this.formIdentitas,
        });
      }
      this.step = 2;
    } finally {
      this.saving = false;
    }
  }

  async saveDraft() {
    if (!this.session) {
      await this.goStep1Next();
    } else {
      this.saving = true;
      try {
        await this.store.updateSession({
          id: this.session.id!,
          data: this.formIdentitas,
        });
      } finally {
        this.saving = false;
      }
    }
  }

  async refreshSession() {
    if (this.session) await this.store.fetchSession(this.session.id!);
  }

  onFinalized() {
    this.$router.push({
      name: "RetensiAlihMediaDetail",
      params: { id: String(this.session?.id) },
    });
  }

  goBack() {
    this.$router.push({ name: "RetensiAlihMediaDaftar" });
  }
}
